import { AudienceFilter, Audience_Status } from '@occc/graphql';

import { StatusType } from '../types';
import { AUDIENCE_STATUS_ALL } from '../constants';

export const getAudienceFilter = (
  chainId: string,
  search: string | undefined,
  status: StatusType,
): AudienceFilter => {
  if (status === undefined) {
    // Exclude "archived" audiences by default
    return {
      chainIdEquals: chainId,
      statusContains: [Audience_Status.Active, Audience_Status.Draft],
      search,
    };
  }

  return {
    chainIdEquals: chainId,
    statusEquals: status !== AUDIENCE_STATUS_ALL ? status : undefined,
    search,
  };
};
